import { ssiConfig } from "../utilities/constant";
import { CyAdvisorConfig } from "../utilities/advisorConfig";

const initialState = {
  user: {},
  loggedIn: false,
  readingUser: true,
  token: localStorage.getItem("wbiAuthToken"),
  message: null,
  advisorConfigUpdating: false,
  advisorConfig: {},
  selectedUser: {},
  signingUp: false,
  userUpdating: false,
  // Request password reset
  requestPwResetResult: "",
  requestPwResetError: "",
  requestingPwReset: false,
  // Reset password
  resetPasswordResult: "",
  resetPasswordError: "",
  resettingPassword: false,
  // acknowledge terms
  acknowledgingTerms: false,
  acknowledgeTermsError: "",
  // Broker dealers
  requestingBrokerDealers: false,
  requestBrokerDealersResult: "",
  requestBrokerDealersError: "",
  // Split Rep Code
  requestingSplitRepCodes: false,
  requestingSplitRepCodesError: "",
};

export default function user(state = initialState, action) {
  let newState;
  switch (action.type) {
    case "USER_AUTH_REQUESTED":
    case "USER_CREATE_REQUESTED":
      return {
        ...state,
        message: null,
        signingUp: true,
      };
    case "USER_AUTH_SUCCESS":
    case "USER_CREATE_SUCCESS":
      return {
        ...state,
        user: action.payload.user,
        token: action.payload.token,
        loggedIn: true,
        signingUp: false,
      };
    case "TOKEN_AUTH_SUCCESS":
      return {
        ...state,
        user: action.payload.user,
        message: null,
        token: action.payload.token,
        loggedIn: false,
        signingUp: false,
      };
    case "LOAD_USER_APPLICATION_STATE_REQUESTED":
      return {
        ...state,
        readingUser: true,
      };
    case "UPDATE_FEES_CUSTODIAN_SUCCESS":
      const prevFees = state.user.custodianFees;

      const custodian = action.payload.custodianId;
      delete prevFees[custodian];
      const updatedFees = prevFees;

      return {
        ...state,
        user: {
          ...state.user,
          custodianFees: updatedFees,
        },
        readingUser: false,
        loggedIn: true,
      };
    case "UPDATE_FEES_ADVISOR_CUSTODIAN_SUCCESS":
      const prevUserFees = state.user.custodianFees;

      const userFees = action.payload.fees;
      const custodianId = action.payload.custodianId;
      delete prevUserFees[custodianId];

      let newUserFees = prevUserFees;
      if (userFees.length > 0) {
        newUserFees[custodianId] = userFees;
      }
      return {
        ...state,
        user: {
          ...state.user,
          custodianFees: newUserFees,
        },
        readingUser: false,
        loggedIn: true,
      };
    case "LOAD_USER_APPLICATION_STATE_SUCCESS":
      return {
        ...state,
        user: {
          ...action.payload.user,
          bdLocked: action.payload.households.some(
            (household) => !!household.RepCodeId
          ),
        },
        readingUser: false,
        loggedIn: true,
      };
    case "LOAD_USER_APPLICATION_STATE_FAIL":
      return {
        ...state,
        readingUser: false,
      };
    case "USER_AUTH_FAIL":
    case "USER_CREATE_FAIL":
      return {
        ...state,
        message: action.payload.response.data.error,
        loggedIn: false,
        signingUp: false,
      };
    case "TOKEN_AUTH_FAIL":
      return {
        ...state,

        loggedIn: false,
        signingUp: false,
        tokenAuthError:
          "Token is no longer valid. Please contact support at info@wbicy.com",
      };
    case "LOGOUT":
      localStorage.removeItem("wbiAuthToken");
      localStorage.removeItem("wbiNavBarOpened");
      return {
        ...state,
        user: {},
        token: null,
        message: null,
        loggedIn: false,
      };
    case "UPDATE_ADVISOR_CONFIG":
      let newUserSettings = Object.assign({}, state.user, action.payload);
      return {
        ...state,
        user: newUserSettings,
      };
    case "ADVISOR_UPDATE_REQUESTED":
      return {
        ...state,
        advisorConfigUpdating: true,
      };
    case "ADVISOR_UPDATE_SUCCESS":
      let userSettings = Object.assign({}, state.user, action.payload);
      return {
        ...state,
        advisorConfigUpdating: false,
        user: userSettings,
      };

    case "ADVISOR_UPDATE_FAIL":
      return {
        ...state,
        advisorConfigUpdating: false,
      };
    case "VIDEO_WATCHED_SUCCESS":
      let newUser = Object.assign({}, state.user, { video_watched: true });
      return {
        ...state,
        user: newUser,
      };
    case "ACKNOWLEDGE_TERMS_REQUESTED":
      return {
        ...state,
        acknowledgingTerms: true,
        acknowledgeTermsError: "",
      };
    case "ACKNOWLEDGE_TERMS_SUCCESS":
      newUser = { ...state.user, ...action.payload.user };
      return {
        ...state,
        acknowledgingTerms: false,
        user: newUser,
      };
    case "ACKNOWLEDGE_TERMS_FAIL":
      return {
        ...state,
        acknowledgingTerms: false,
        acknowledgeTermsError: action.payload.response.data.error,
      };
    case "USER_FETCH_SUCCESS":
      const { custodianFees, platformFees, ...rest } = action.payload.user;

      return {
        ...state,
        selectedUser: rest,
      };
    case "USER_UPDATE_REQUESTED":
    case "USER_BD_REP_CODE_UPDATE_REQUESTED":
      return {
        ...state,
        userUpdating: true,
        message: null,
      };
    case "USER_UPDATE_SUCCESS":
    case "USER_BD_REP_CODE_UPDATE_SUCCESS":
      newState = {
        ...state,
        userUpdating: false,
        message: { success: action.payload.message, error: null },
      };

      if (action.payload.user.id === state.user.id) {
        newState.user = Object.assign({}, action.payload.user);
      }

      return newState;
    case "USER_UPDATE_FAIL":
    case "USER_BD_REP_CODE_UPDATE_FAIL":
      return {
        ...state,
        userUpdating: false,
        message: { success: null, error: action.payload.response.data.error },
      };
    case "USER_REQUEST_PW_RESET_REQUESTED":
      return {
        ...state,
        requestingPwReset: true,
        requestPwResetResult: "",
        requestPwResetError: "",
      };
    case "USER_REQUEST_PW_RESET_SUCCESS":
      return {
        ...state,
        requestingPwReset: false,
        requestPwResetResult: action.payload.message,
        requestPwResetError: "",
      };
    case "USER_REQUEST_PW_RESET_FAIL":
      return {
        ...state,
        requestingPwReset: false,
        requestPwResetError: action.payload.response.data.error,
      };
    case "USER_PASSWORD_RESET_REQUESTED":
      return {
        ...state,
        resettingPassword: true,
        resetPasswordResult: "",
        resetPasswordError: "",
      };
    case "USER_PASSWORD_RESET_SUCCESS":
      return {
        ...state,
        resettingPassword: false,
        resetPasswordResult: action.payload.message,
        resetPasswordError: "",
      };
    case "USER_PASSWORD_RESET_FAIL":
      return {
        ...state,
        resettingPassword: false,
        resetPasswordError: action.payload.response.data.error,
      };
    case "BROKER_DEALERS_REQUESTED":
      return {
        ...state,
        requestingBrokerDealers: true,
        requestBrokerDealersResult: "",
        requestBrokerDealersError: "",
      };
    case "BROKER_DEALERS_SUCCESS":
      return {
        ...state,
        requestingBrokerDealers: false,
        requestBrokerDealersResult: action.payload.message,
        requestBrokerDealersError: "",
      };
    case "BROKER_DEALERS_FAIL":
      return {
        ...state,
        requestingBrokerDealers: false,
        requestBrokerDealersError: action.payload.response.data.error,
      };
    case "REP_CODE_UPDATE_REQUESTED":
      return {
        ...state,
        requestingSplitRepCodes: true,
        requestingSplitRepCodesError: "",
      };
    case "REP_CODE_UPDATE_SUCCESS":
      newState = {
        ...state,
        user: action.payload.user,
        requestingSplitRepCodes: false,
        requestingSplitRepCodesError: "",
      };

      return newState;
    case "REP_CODE_UPDATE_FAIL":
      return {
        ...state,
        requestingSplitRepCodes: false,
        requestingSplitRepCodesError: action.payload.error,
      };
    case "MULTI_PORTFOLIO_ONBOARD_SUCCESS":
      return {
        ...state,
        user: { ...state.user, bdLocked: true },
      };
    case "CLEAR_USER_ERROR_MESSAGE": {
      return {
        ...state,
        message: null,
      };
    }
    case "CREATE_JIRA_USER":
      return {
        ...state,
        user: { ...state.user, jiraId: action.payload },
      };
    case "SET_APP_CUSTOM_CONFIGURATION": {
      const appName = action.payload.appName;
      const advisorConfig = CyAdvisorConfig.getAdvisorConfig(appName);
      return {
        ...state,
        advisorConfig: {...advisorConfig, ...ssiConfig}
      }
    }
    default:
      return { ...state };
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user.reducer.js